module.exports = __webpack_public_path__ + "img/6.0d9fc2ba.jpg";